import React from 'react';
import { WAVE_LABELS } from '../../types/annotation';

export default function NodePalette({ activeLabel, onSelect, disabled }) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      <span className="text-[10px] uppercase tracking-wider text-[#8b93a7] font-mono mr-2">
        Place Wave:
      </span>
      {WAVE_LABELS.map(({ label, type, color }) => {
        const isActive = activeLabel === label;
        return (
          <button
            key={label}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(isActive ? null : label)}
            className={`
              w-8 h-8 rounded-full border-2 text-[11px] font-mono font-bold
              transition-all duration-200 flex items-center justify-center
              ${isActive
                ? `border-[${color}] bg-[${color}]/20 text-[${color}] shadow-[0_0_12px_rgba(${
                    type === 'motive' ? '245,180,0' : '0,245,212'
                  },0.3)] scale-110`
                : `border-white/20 bg-black/40 text-white/60 hover:border-[${color}]/50 hover:text-[${color}]`
              }
              disabled:opacity-30 disabled:cursor-not-allowed
            `}
            style={isActive ? {
              borderColor: color,
              backgroundColor: `${color}20`,
              color: color,
              boxShadow: `0 0 12px ${color}40`,
              transform: 'scale(1.1)',
            } : {}}
            title={`Place Wave ${label} (${type})`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
